import { PageDtoResponse } from '@asset-metrix/portal-gateway-client-js';
import { QueryFunction } from '@tanstack/react-query';

import {
  QueryKeyWithRole,
  unwrapQueryKeyWithRole,
} from '../../utils/prependRoleId';
import { portalGatewayClient } from '../portalGatewayClient';

export type PageQueryKey = readonly [string];

export const fetchPage: QueryFunction<
  PageDtoResponse,
  QueryKeyWithRole<PageQueryKey>
> = async ({ queryKey }) => {
  const [pageId] = unwrapQueryKeyWithRole(queryKey).params;

  try {
    const response = await portalGatewayClient.page.getPage(pageId);
    return response.data;
  } catch (e: unknown) {
    console.error(e);
    throw e;
  }
};
